let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cZZNt")).then(() => parcelRequire('eBN7E'));